module.exports = __webpack_public_path__ + "static/manifest.983fbe62.webmanifest";